"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TokenValidationError = require("./TokenValidationError");
Object.keys(_TokenValidationError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenValidationError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TokenValidationError[key];
    }
  });
});